import React, { useContext, useState } from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../components/MCSPagedTable';
import MCSLoading from '../../../components/MCSLoading';
import { DateHelper } from '../../../_helpers/DateHelper';
import Badge from "@visa/vds/badge";
import BadgeDot from "@visa/vds/badge-dot";


function UserAnnouncementsTable(props) {
    const PAGE_SIZE = props.PAGE_SIZE
    let colHeaders = [
        { displayName: "", name: "", orderable: false },
        { displayName: "Publish Date", name: "Date", orderable: false },
        { displayName: "", name: "", orderable: false },
        { displayName: "Announcement", name: "AnnouncementName", orderable: false },
        { displayName: "", name: "", orderable: false },
        { displayName: "", name: "", orderable: false },
        { displayName: "", name: "actions", orderable: false },
        { displayName: "", name: "", orderable: false },
        { displayName: "", name: "", orderable: false },
        { displayName: "", name: "", orderable: false }
    ];

    const [selectedPage, setSelectedPage] = useState(1)

    const fetchDataOnPageChange = (page) => {
        setSelectedPage(page);
        props.fetch(page);
    }
    React.useEffect(() => {
        setSelectedPage(1)
    }, [props.changeState]);

    if (!props.fetched) {
        return (<MCSLoading />)
    }
    else {
        return (
            <>
                <MCSPagedTable size={"compact"}
                    colHeaders={colHeaders}
                    useSearchBar={false}
                    usePagination={true}
                    selectedPage={selectedPage} setSelectedPage={fetchDataOnPageChange} totalPages={props.totalPages}
                    tableData={
                        props.data && props.data.items.map((row, key) => (
                            <Tr key={key}>
                                <Td></Td>
                                <Td>{DateHelper.ToLocaleDateString(row.startDate)}</Td>
                                <Td>
                                    <Badge type="neutral">
                                        <BadgeDot />
                                        {(row.us && row.canada && row.eu && row.ap && row.lac && row.cemea) ? "GLOBAL" : "REGIONAL"}
                                    </Badge>
                                </Td>
                                <Td style={{wordBreak:"break-all"}}>
                                    <a href="#"
                                    onClick={(event) => {
                                        props.setSelectedAnnouncement(row);
                                        event.preventDefault();
                                    }}>
                                    <u>{row.announcementName}</u></a></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                            </Tr>
                        ))
                   }
                />
            </>
        );
    }
}

export default UserAnnouncementsTable;
